// jkwan 20230821 - rendered in theme.liquid, for Social Impact page to default expand first accordion of Impact Pillars section
window.onload = function () {
  window.addEventListener(
    "scroll",
    function () {
      document.querySelector("dt:first-of-type button").click();
    },
    { once: true }
  );
};
